import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { axiosInt } from '../../../utils';
import { API_IDENTITY_URL } from '../../../utils';
import type { IUser } from '../../../types/user';
import type { IBaseTableParams, IPaginateData } from '../../../types';

export const FETCH_USERS_KEY = 'fetchUsers';
export const fetchUsers = async (
  params: IBaseTableParams
): Promise<IPaginateData<IUser>> => {
  const response = await axiosInt.get(`${API_IDENTITY_URL}/users`, { params });
  return response.data;
};

const useFetchUsers = ({
  params,
  options,
}: {
  params: IBaseTableParams;
  options?: Partial<UseQueryOptions<IPaginateData<IUser>>>;
}) => {
  const {
    data: users,
    isLoading: isLoadingUsers,
    error: errorFetchingUsers,
  } = useQuery<IPaginateData<IUser>>({
    queryKey: [FETCH_USERS_KEY, params],
    queryFn: () => fetchUsers(params),
    placeholderData: prev => prev,
    ...options,
  });

  return {
    users,
    isLoadingUsers,
    errorFetchingUsers,
  };
};

export default useFetchUsers;
